if (!customElements.get('cart-document-fields')) {
  customElements.define('cart-document-fields', class CartDocumentFields extends HTMLElement {
    static instances = [];
    static listenersBound = false;
    static comunasByRegion = {
      'Arica y Parinacota': ['Arica', 'Camarones', 'General Lagos', 'Putre'],
      'Tarapacá': ['Alto Hospicio', 'Camiña', 'Colchane', 'Huara', 'Iquique', 'Pica', 'Pozo Almonte'],
      'Antofagasta': ['Antofagasta', 'Calama', 'María Elena', 'Mejillones', 'Ollagüe', 'San Pedro de Atacama', 'Sierra Gorda', 'Taltal', 'Tocopilla'],
      'Atacama': ['Alto del Carmen', 'Caldera', 'Chañaral', 'Copiapó', 'Diego de Almagro', 'Freirina', 'Huasco', 'Tierra Amarilla', 'Vallenar'],
      'Coquimbo': ['Andacollo', 'Canela', 'Combarbalá', 'Coquimbo', 'Illapel', 'La Higuera', 'La Serena', 'Los Vilos', 'Monte Patria', 'Ovalle', 'Paiguano', 'Punitaqui', 'Río Hurtado', 'Salamanca', 'Vicuña'],
      'Valparaíso': ['Algarrobo', 'Cabildo', 'Calera', 'Calle Larga', 'Cartagena', 'Casablanca', 'Catemu', 'Concón', 'El Quisco', 'El Tabo', 'Hijuelas', 'Isla de Pascua', 'Juan Fernández', 'La Cruz', 'La Ligua', 'Limache', 'Llaillay', 'Los Andes', 'Nogales', 'Olmué', 'Panquehue', 'Papudo', 'Petorca', 'Puchuncaví', 'Putaendo', 'Quillota', 'Quilpué', 'Quintero', 'Rinconada', 'San Antonio', 'San Esteban', 'San Felipe', 'Santa María', 'Santo Domingo', 'Valparaíso', 'Villa Alemana', 'Viña del Mar', 'Zapallar'],
      'Región Metropolitana': ['Alhué', 'Buin', 'Calera de Tango', 'Cerrillos', 'Cerro Navia', 'Colina', 'Conchalí', 'Curacaví', 'El Bosque', 'El Monte', 'Estación Central', 'Huechuraba', 'Independencia', 'Isla de Maipo', 'La Cisterna', 'La Florida', 'La Granja', 'La Pintana', 'La Reina', 'Lampa', 'Las Condes', 'Lo Barnechea', 'Lo Espejo', 'Lo Prado', 'Macul', 'Maipú', 'María Pinto', 'Melipilla', 'Ñuñoa', 'Padre Hurtado', 'Paine', 'Pedro Aguirre Cerda', 'Peñaflor', 'Peñalolén', 'Pirque', 'Providencia', 'Pudahuel', 'Puente Alto', 'Quilicura', 'Quinta Normal', 'Recoleta', 'Renca', 'San Bernardo', 'San Joaquín', 'San José de Maipo', 'San Miguel', 'San Pedro', 'San Ramón', 'Santiago', 'Talagante', 'Tiltil', 'Vitacura'],
      "O'Higgins": ['Chépica', 'Chimbarongo', 'Codegua', 'Coínco', 'Coltauco', 'Doñihue', 'Graneros', 'La Estrella', 'Las Cabras', 'Litueche', 'Lolol', 'Machalí', 'Malloa', 'Marchihue', 'Mostazal', 'Nancagua', 'Navidad', 'Olivar', 'Palmilla', 'Paredones', 'Peralillo', 'Peumo', 'Pichidegua', 'Pichilemu', 'Placilla', 'Pumanque', 'Quinta de Tilcoco', 'Rancagua', 'Rengo', 'Requínoa', 'San Fernando', 'San Vicente', 'Santa Cruz'],
      'Maule': ['Cauquenes', 'Chanco', 'Colbún', 'Constitución', 'Curepto', 'Curicó', 'Empedrado', 'Hualañé', 'Licantén', 'Linares', 'Longaví', 'Maule', 'Molina', 'Parral', 'Pelarco', 'Pelluhue', 'Pencahue', 'Rauco', 'Retiro', 'Río Claro', 'Romeral', 'Sagrada Familia', 'San Clemente', 'San Javier', 'San Rafael', 'Talca', 'Teno', 'Vichuquén', 'Villa Alegre', 'Yerbas Buenas'],
      'Ñuble': ['Bulnes', 'Chillán', 'Chillán Viejo', 'Cobquecura', 'Coelemu', 'Coihueco', 'El Carmen', 'Ninhue', 'Ñiquén', 'Pemuco', 'Pinto', 'Portezuelo', 'Quillón', 'Quirihue', 'Ránquil', 'San Carlos', 'San Fabián', 'San Ignacio', 'San Nicolás', 'Treguaco', 'Yungay'],
      'Biobío': ['Alto Biobío', 'Antuco', 'Arauco', 'Cabrero', 'Cañete', 'Chiguayante', 'Concepción', 'Contulmo', 'Coronel', 'Curanilahue', 'Florida', 'Hualpén', 'Hualqui', 'Laja', 'Lebu', 'Los Álamos', 'Los Ángeles', 'Lota', 'Mulchén', 'Nacimiento', 'Negrete', 'Penco', 'Quilaco', 'Quilleco', 'San Pedro de la Paz', 'San Rosendo', 'Santa Bárbara', 'Santa Juana', 'Talcahuano', 'Tirúa', 'Tomé', 'Tucapel', 'Yumbel'],
      'Araucanía': ['Angol', 'Carahue', 'Cholchol', 'Collipulli', 'Cunco', 'Curacautín', 'Curarrehue', 'Ercilla', 'Freire', 'Galvarino', 'Gorbea', 'Lautaro', 'Loncoche', 'Lonquimay', 'Los Sauces', 'Lumaco', 'Melipeuco', 'Nueva Imperial', 'Padre Las Casas', 'Perquenco', 'Pitrufquén', 'Pucón', 'Purén', 'Renaico', 'Saavedra', 'Temuco', 'Teodoro Schmidt', 'Toltén', 'Traiguén', 'Victoria', 'Vilcún', 'Villarrica'],
      'Los Ríos': ['Corral', 'Futrono', 'La Unión', 'Lago Ranco', 'Lanco', 'Los Lagos', 'Máfil', 'Mariquina', 'Paillaco', 'Panguipulli', 'Río Bueno', 'Valdivia'],
      'Los Lagos': ['Ancud', 'Calbuco', 'Castro', 'Chaitén', 'Chonchi', 'Cochamó', 'Curaco de Vélez', 'Dalcahue', 'Fresia', 'Frutillar', 'Futaleufú', 'Hualaihué', 'Llanquihue', 'Los Muermos', 'Maullín', 'Osorno', 'Palena', 'Puerto Montt', 'Puerto Octay', 'Puerto Varas', 'Puqueldón', 'Purranque', 'Puyehue', 'Queilén', 'Quellón', 'Quemchi', 'Quinchao', 'Río Negro', 'San Juan de la Costa', 'San Pablo'],
      'Aysén': ['Aysén', 'Chile Chico', 'Cisnes', 'Cochrane', 'Coyhaique', 'Guaitecas', 'Lago Verde', "O'Higgins", 'Río Ibáñez', 'Tortel'],
      'Magallanes': ['Antártica', 'Cabo de Hornos', 'Laguna Blanca', 'Natales', 'Porvenir', 'Primavera', 'Punta Arenas', 'Río Verde', 'San Gregorio', 'Timaukel', 'Torres del Paine']
    };

    constructor() {
      super();
      this.formId = this.dataset.formId;
      this.documentTypeInputs = this.querySelectorAll('[name="attributes[Tipo de documento]"]');
      this.addressInputs = this.querySelectorAll('[data-address-input]');
      this.regionSelect = this.querySelector('[data-region-select]');
      this.comunaSelect = this.querySelector('[data-comuna-select]');
      this.facturaFields = this.querySelector('[data-factura-fields]');
      this.facturaInputs = this.querySelectorAll('[data-factura-input]');
      this.errorElement = this.querySelector('[data-document-error]');
      this.save = debounce(this.save.bind(this), ON_CHANGE_DEBOUNCE_TIMER);
    }

    connectedCallback() {
      if (!this.documentTypeInputs.length || !this.facturaFields || !this.regionSelect || !this.comunaSelect) return;

      this.documentTypeInputs.forEach((input) => {
        input.addEventListener('change', () => {
          this.syncFields();
          this.hideError();
          this.save();
        });
      });

      this.addressInputs.forEach((input) => {
        input.addEventListener('change', () => {
          input.setCustomValidity('');
          this.hideError();
          this.save();
        });
      });

      this.regionSelect.addEventListener('change', () => {
        this.populateComunas('');
        this.comunaSelect.setCustomValidity('');
        this.hideError();
        this.save();
      });

      this.facturaInputs.forEach((input) => {
        input.addEventListener('input', () => {
          input.setCustomValidity('');
          this.hideError();
          this.save();
        });
      });

      this.populateComunas(this.comunaSelect.dataset.selectedComuna || '');
      this.syncFields();
      CartDocumentFields.instances.push(this);
      CartDocumentFields.bindGlobalListeners();
    }

    disconnectedCallback() {
      CartDocumentFields.instances = CartDocumentFields.instances.filter((instance) => instance !== this);
    }

    static bindGlobalListeners() {
      if (CartDocumentFields.listenersBound) return;

      document.addEventListener('submit', (event) => {
        const instance = CartDocumentFields.findByForm(event.target.id);
        if (!instance || !instance.shouldValidateSubmit(event)) return;

        if (!instance.validate()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        } else {
          instance.saveNow();
        }
      }, true);

      document.addEventListener('click', (event) => {
        const checkoutButton = event.target.closest('[name="checkout"][form]');
        if (checkoutButton) {
          const instance = CartDocumentFields.findByForm(checkoutButton.getAttribute('form'));
          if (!instance) return;

          if (!instance.validate()) {
            event.preventDefault();
            event.stopImmediatePropagation();
          } else {
            instance.saveNow();
          }

          return;
        }

        const dynamicCheckout = event.target.closest('.cart__dynamic-checkout-buttons');
        if (!dynamicCheckout) return;

        const instance = CartDocumentFields.findNear(dynamicCheckout);
        if (!instance) return;

        if (!instance.validate()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        } else {
          instance.saveNow();
        }
      }, true);

      CartDocumentFields.listenersBound = true;
    }

    static findByForm(formId) {
      return CartDocumentFields.instances.find((instance) => instance.formId === formId);
    }

    static findNear(element) {
      const wrapper = element.closest('.cart__footer, .drawer__footer');
      if (!wrapper) return CartDocumentFields.instances[0];

      return CartDocumentFields.instances.find((instance) => wrapper.contains(instance));
    }

    shouldValidateSubmit(event) {
      const submitter = event.submitter || document.activeElement;
      return submitter && submitter.getAttribute('name') === 'checkout';
    }

    get documentType() {
      const checkedInput = Array.from(this.documentTypeInputs).find((input) => input.checked);
      return checkedInput ? checkedInput.value : 'Boleta';
    }

    populateComunas(selectedComuna) {
      const region = this.regionSelect.value;
      const comunas = CartDocumentFields.comunasByRegion[region] || [];

      this.comunaSelect.innerHTML = '';
      this.comunaSelect.append(new Option('Selecciona tu Comuna', ''));
      this.comunaSelect.disabled = comunas.length === 0;

      comunas.forEach((comuna) => {
        const option = new Option(comuna, comuna);
        option.selected = comuna === selectedComuna;
        this.comunaSelect.append(option);
      });

      if (!comunas.includes(selectedComuna)) {
        this.comunaSelect.value = '';
      }
    }

    syncFields() {
      const isFactura = this.documentType === 'Factura';
      this.facturaFields.classList.toggle('hidden', !isFactura);

      this.addressInputs.forEach((input) => {
        input.required = true;
        input.setCustomValidity('');
      });

      this.facturaInputs.forEach((input) => {
        input.required = isFactura;
        input.setCustomValidity('');
        if (!isFactura) input.value = '';
      });
    }

    validate() {
      const firstEmptyAddressInput = Array.from(this.addressInputs).find((input) => input.value.trim() === '');

      if (firstEmptyAddressInput) {
        this.showError('Por favor selecciona Región y Comuna antes de continuar.');
        firstEmptyAddressInput.setCustomValidity('Por favor selecciona Región y Comuna antes de continuar.');
        firstEmptyAddressInput.focus();
        return false;
      }

      if (this.documentType !== 'Factura') {
        this.hideError();
        return true;
      }

      const firstEmptyFacturaInput = Array.from(this.facturaInputs).find((input) => input.value.trim() === '');

      if (!firstEmptyFacturaInput) {
        this.hideError();
        return true;
      }

      this.showError('Por favor completa los datos de facturación para solicitar factura.');
      firstEmptyFacturaInput.setCustomValidity('Por favor completa los datos de facturación para solicitar factura.');
      firstEmptyFacturaInput.focus();
      return false;
    }

    showError(message) {
      if (!this.errorElement) return;
      if (message) this.errorElement.textContent = message;
      this.errorElement.hidden = false;
    }

    hideError() {
      if (!this.errorElement) return;
      this.errorElement.hidden = true;
    }

    saveNow() {
      fetch(`${routes.cart_update_url}`, {
        ...fetchConfig(),
        body: JSON.stringify({ attributes: this.buildAttributes() })
      }).catch((error) => {
        console.error(error);
      });
    }

    buildAttributes() {
      const attributes = {
        'Tipo de documento': this.documentType,
        'Región': this.regionSelect.value,
        'Comuna': this.comunaSelect.value,
        'Razón social': '',
        'RUT empresa': '',
        'Dirección de facturación': '',
        'Email para factura': '',
        'Razon social': '',
        'Direccion facturacion': '',
        'Correo factura': ''
      };

      if (this.documentType === 'Factura') {
        this.facturaInputs.forEach((input) => {
          const match = input.name.match(/^attributes\[(.+)]$/);
          if (match) attributes[match[1]] = input.value.trim();
        });
      }

      return attributes;
    }

    save() {
      fetch(`${routes.cart_update_url}`, {
        ...fetchConfig(),
        body: JSON.stringify({ attributes: this.buildAttributes() })
      }).catch((error) => {
        console.error(error);
      });
    }
  });
}
